import { call, put, takeLatest, delay, select } from "redux-saga/effects"
import { documentsService } from "../services/documents.services"
import { buildContentService } from "../services/build_content.services"
import axiosClient from "axios"
import axios from "../services/axios"
import { clearMultibase } from "../actions/multiAiBase"

import {
	REQUEST_SEARCH_TYPING,
	SEARCH_TYPING,
	SEARCH_SET_SOURCE_FILTER,
	SEARCH_SUCCESS,
	SEARCH_CLEAR_CONCEPT_TARGET_TERMS,
	SEARCH_ADD_CONCEPT_TARGET_TERMS,
	LOGOUT,
	SEARCH_ERROR,
	SHOW_ALERT,
	JOB_STATUS_SUCCESS,
	JOB_STATUS_PENDING,
	TIMELINE_SEARCH_TYPING,
	TIMELINE_SET_SOURCE_FILTER,
	TIMELINE_SEARCH_SUCCESS,
	TIMELINE_SEARCH_CLEAR_CONCEPT_TARGET_TERMS,
	TIMELINE_SEARCH_ADD_CONCEPT_TARGET_TERMS,
	TIMELINE_SEARCH_ERROR,
	SEARCH_DOCS_DATA_SUCCESS,
	TIMELINE_SEARCH_DOCS_DATA_SUCCESS,
} from "../types/index"
import { clearLocalStorage, reSortArray, searchTermParse } from "../utils"

const getPsearchStatusByJobId = async (id) => {
	return await axios.get(`/p_search/${id}`).catch((e) => console.log(e))
}

const getStatusByJobId = async (id) => {
	return await axios.get(`/job/${id}`).catch((e) => console.log(e))
}

function* getTargetTermsOfCategory(categories) {
	const state = yield select()
	const saved_concepts = state.buildconcept.user_saved_build_concepts
	for (let category of categories) {
		//find id in saved_concepts
		var idConcept = saved_concepts.find((item) => {
			return item.id === category
		})
		if (idConcept) {
			// const response =  await buildContentService.conceptIndividual(idConcept.ext_id);
			const response = yield call(buildContentService.conceptIndividual, idConcept.id)
			try {
				if (response.data.concept.topic.terms.length > 0) {
					var negativeC = response.data.concept.visual.neg_phrase_count
					var positiveC = response.data.concept.visual.phrase_count
					//need to join in one array topic.terms and topic.relatedness
					let combined = []
					for (var i = 0; i < response.data.concept.topic.terms.length; i++) {
						combined.push([response.data.concept.topic.relatedness[i], response.data.concept.topic.terms[i]])
					}
					let positiveSearch = combined
						.filter((i) => i[0] >= 0)
						.slice(0, positiveC)
						.map((i) => i[1])
					let negativeSearch = combined
						.filter((i) => i[0] < 0)
						.slice(0, negativeC)
						.map((i) => i[1])
					// dispatch(callUpdateSearchConceptTargetTerms(positiveSearch));
					yield put({
						type: SEARCH_ADD_CONCEPT_TARGET_TERMS,
						payload: positiveSearch,
					})
					yield put({
						type: TIMELINE_SEARCH_ADD_CONCEPT_TARGET_TERMS,
						payload: positiveSearch,
					})
				}
			} catch (error) {
				console.log(error)
				try {
					if (error.response.status === 403) {
						clearLocalStorage()
						yield put(clearMultibase())
						// dispatch(errorUser());
						yield put({
							type: LOGOUT,
							payload: null,
						})
						return
					}
				} catch (e) {
					console.log(e)
				}
			}
		}
	}
}

function* newSearchSearchFlow(action) {
	const state = yield select()
	const { searchObject, filter, categories, cancelToken, location, selectedTag } = action.payload
	if (location === "search") {
		// dispatch(requestSearchAPI());
		yield put({
			type: SEARCH_TYPING,
			payload: true,
		})

		try {
			let sourceApi = state.sources.docs_sources
			//Get from API
			// dispatch(setCurrentSourceFilter(filter));
			yield put({
				type: SEARCH_SET_SOURCE_FILTER,
				payload: filter,
			})

			const searchTearms = searchTermParse(searchObject)
			// const response = await documentsService.toolsSearch(searchObject,"",filter,categories, false, 10000 ,cancelToken, sourceApi);
			const response = yield call(
				documentsService.toolsSearch,
				searchTearms,
				"",
				filter,
				categories,
				false,
				10000,
				cancelToken,
				sourceApi,
				selectedTag
			)
			let jobId = yield call(getStatusByJobId, response.data.job_id)

			while ((jobId?.data && jobId.data.job.job_status.success === false) || jobId.data.job.job_status.is_finished === false) {
				yield delay(1000)
				jobId = yield call(getStatusByJobId, response.data.job_id)
			}

			if (jobId?.data && jobId.data.job.job_status.success === true) {
				yield put({
					type: JOB_STATUS_SUCCESS,
					payload: {
						jobId: response.data.job_id,
						status: jobId.data.job.job_status.success,
						location: location,
					},
				})

				const concept = yield call(getPsearchStatusByJobId, response.data.job_id)

				const docIdArray = []
				for (var i = 0; i < concept.data.data.data.length; i++) {
					docIdArray.push(`${concept.data.data.data[i].id}`)
				}

				const response_docsData = yield call(documentsService.getDocumentsMetadata, docIdArray)
				const sortData = reSortArray(docIdArray, response_docsData.data.data)

				yield put({
					type: SEARCH_DOCS_DATA_SUCCESS,
					payload: sortData,
				})
				// dispatch(requestSearchAPISuccess(response.data));
				yield put({
					type: SEARCH_SUCCESS,
					payload: {
						conceptData: concept.data,
						responseDocsData: sortData,
					},
				})
				// dispatch(callClearSearchConceptTargetTerms(searchObject));
				yield put({
					type: SEARCH_CLEAR_CONCEPT_TARGET_TERMS,
					payload: searchTearms,
				})
				if (categories.length > 0) {
					yield call(getTargetTermsOfCategory, categories)
				}
				// dispatch(callUpdateSearchConceptTargetTerms(searchObject));
				yield put({
					type: SEARCH_ADD_CONCEPT_TARGET_TERMS,
					payload: searchTearms,
				})
			} else {
				yield put({
					type: JOB_STATUS_PENDING,
					payload: {
						jobId: response.data.job_id,
						status: jobId.data.job.job_status.success,
						location: location,
					},
				})
			}
		} catch (error) {
			console.log(error)
			try {
				if (axiosClient.isCancel(error)) {
					//('Request canceled', error.message);
				} else {
					if (error.response.status === 403) {
						clearLocalStorage()
						yield put(clearMultibase())
						// dispatch(errorUser());
						yield put({
							type: LOGOUT,
							payload: null,
						})
						return
					}
					// dispatch(requestSearchAPIError(true));
					yield put({
						type: SEARCH_ERROR,
						payload: true,
					})
					// dispatch(alertActions.showAlertAction({
					//         msg: 'There was an error. Please, try again and check your connection',
					//         class: 'alert alert-danger'
					//     }));
					// }
					let alert = {
						msg: "There was an error. Please, try again and check your connection",
						class: "alert alert-danger",
					}
					yield put({
						type: SHOW_ALERT,
						payload: alert,
					})
				}
			} catch (e) {
				console.log(e)
			}
		}
	} else if (location === "timeline") {
		// dispatch(requestSearchAPI());
		yield put({
			type: TIMELINE_SEARCH_TYPING,
			payload: true,
		})

		try {
			let sourceApi = state.sources.docs_sources
			//Get from API
			// dispatch(setCurrentSourceFilter(filter));
			yield put({
				type: TIMELINE_SET_SOURCE_FILTER,
				payload: filter,
			})

			const searchTearms = searchTermParse(searchObject)
			// const response = await documentsService.toolsSearch(searchObject,"",filter,categories, false, 10000 ,cancelToken, sourceApi);
			const response = yield call(
				documentsService.toolsSearch,
				searchTearms,
				"",
				filter,
				categories,
				false,
				10000,
				cancelToken,
				sourceApi
			)
			let jobId = yield call(getStatusByJobId, response.data.job_id)

			while ((jobId?.data && jobId.data.job.job_status.success === false) || jobId.data.job.job_status.is_finished === false) {
				yield delay(1000)
				jobId = yield call(getStatusByJobId, response.data.job_id)
			}

			if (jobId?.data && jobId.data.job.job_status.success === true) {
				yield put({
					type: JOB_STATUS_SUCCESS,
					payload: {
						jobId: response.data.job_id,
						status: jobId.data.job.job_status.success,
						location: location,
					},
				})

				const concept = yield call(getPsearchStatusByJobId, response.data.job_id)
				const docIdArray = []
				for (var i = 0; i < concept.data.data.data.length; i++) {
					docIdArray.push(`${concept.data.data.data[i].id}`)
				}
				const response_docsData = yield call(documentsService.getDocumentsMetadata, docIdArray)
				const sortData = reSortArray(docIdArray, response_docsData.data.data)

				yield put({
					type: TIMELINE_SEARCH_DOCS_DATA_SUCCESS,
					payload: sortData,
				})
				// dispatch(requestSearchAPISuccess(response.data));
				yield put({
					type: TIMELINE_SEARCH_SUCCESS,
					payload: {
						conceptData: concept.data,
						responseDocsData: sortData,
					},
				})
				// dispatch(callClearSearchConceptTargetTerms(searchObject));
				yield put({
					type: TIMELINE_SEARCH_CLEAR_CONCEPT_TARGET_TERMS,
					payload: searchTearms,
				})
				if (categories.length > 0) {
					yield call(getTargetTermsOfCategory, categories)
				}
				// dispatch(callUpdateSearchConceptTargetTerms(searchObject));
				yield put({
					type: TIMELINE_SEARCH_ADD_CONCEPT_TARGET_TERMS,
					payload: searchTearms,
				})
			} else {
				yield put({
					type: JOB_STATUS_PENDING,
					payload: {
						jobId: response.data.job_id,
						status: jobId.data.job.job_status.success,
						location: location,
					},
				})
			}
		} catch (error) {
			console.log(error)
			try {
				if (axiosClient.isCancel(error)) {
					//('Request canceled', error.message);
				} else {
					if (error.response.status === 403) {
						clearLocalStorage()
						yield put(clearMultibase())
						// dispatch(errorUser());
						yield put({
							type: LOGOUT,
							payload: null,
						})
						return
					}
					// dispatch(requestSearchAPIError(true));
					yield put({
						type: TIMELINE_SEARCH_ERROR,
						payload: true,
					})
					// dispatch(alertActions.showAlertAction({
					//         msg: 'There was an error. Please, try again and check your connection',
					//         class: 'alert alert-danger'
					//     }));
					// }
					let alert = {
						msg: "There was an error. Please, try again and check your connection",
						class: "alert alert-danger",
					}
					yield put({
						type: SHOW_ALERT,
						payload: alert,
					})
				}
			} catch (e) {
				console.log(e)
			}
		}
	} else if (location === "buildConcept") {
		console.log("search en build")
	}
}

// Watches for the UPDATEACCOUNTDETAILS_REQUESTING action type
// When it gets it, it will call verificarFlow()
// WITH the action we dispatched
function* searchWatcher() {
	// takeLatest() takes the LATEST call of that action and runs it
	// if we we're to use takeEvery, it would take every single
	// one of the actions and kick off a new task to handle it
	// CONCURRENTLY!!!
	yield takeLatest(REQUEST_SEARCH_TYPING, newSearchSearchFlow)
}

export default searchWatcher
